import React from "react";
import styled from "@emotion/styled";

import Button from "shared/components/Button";
import JoinRemaxForm from "./form";
import { useTranslations } from "next-intl";

function JoinRemax() {
  const translation = useTranslations("join");
  const translationJoinUs = useTranslations("join.joinUs");
  return (
    <Wrapper>
      <BackgroundImage>
        <Image
          src="/images/image-optimize/multi-agents-join-remax.png"
          alt="Bienvenido a tu nueva casa Remax República Dominicana"
        />
      </BackgroundImage>
      <CoverDetails>
        <CoverContainer className="container">
          <CoverContent>
            <CoverTitle>{translation("title")}</CoverTitle>
            <CoverText>{translationJoinUs("description")}</CoverText>
            <CoverText>{translationJoinUs("control")}</CoverText>
            <CoverText>{translationJoinUs("remaxBranch")}</CoverText>
            {/* <JoinRemaxForm> */}
            <a href="https://reclutamiento.remaxrd.com/" target="_blank" rel="noopener noreferrer">
              <CoverButton component="a">
                {translationJoinUs("joinFamily")}
              </CoverButton>
              {/* </JoinRemaxForm> */}
            </a>
          </CoverContent>
        </CoverContainer>
      </CoverDetails>
    </Wrapper >
  );
}

const Wrapper = styled.section`
  width: 100%;
  position: relative;
`;

const BackgroundImage = styled.div`
  width: 100%;
  height: 984px;
  background-color: var(--white);

  @media screen and (max-width: 991px) {
    height: 65vw;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const CoverDetails = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;

  @media screen and (max-width: 991px) {
    position: static;
    background-color: #1f3565;
  }
`;

const CoverContainer = styled.div`
  height: 100%;
  position: relative;
`;

const CoverContent = styled.div`
  position: absolute;
  left: 0;
  top: 190px;
  width: 563px;
  padding: 40px 57px 100px;
  background-color: #1f3565;

  @media screen and (max-width: 991px) {
    position: static;
    width: 100%;
  }

  @media screen and (max-width: 767px) {
    padding: 80px 20px;
  }
`;

const CoverTitle = styled.h1`
  font-size: 1.938rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 33px;
  @media screen and (max-width: 480px) {
    // white-space: nowrap;
    font-size: 1.638rem;

    // line-height: 10px;
  }
`;

const CoverText = styled.p`
  color: #fff;
  font-size: 0.938rem;
  font-weight: 500;
  margin-bottom: 20px;
  line-height: 29px;
`;

const CoverButton = styled(Button)`
  width: 100%;
  max-width: 265px;
  position: absolute;
  bottom: -20px;
  margin: 0 auto;
  left: 50%;
  transform: translateX(-50%);
  text-decoration: none;
`;

export default JoinRemax;
